<template>
    <div class="crm-tickets">
        <div class="tickets-toolbar">
            <div class="view-toggle-group">
                <b-button
                    :variant="viewMode === 'list' ? 'primary' : 'outline-primary'"
                    size="sm"
                    class="toggle-btn"
                    @click="viewMode = 'list'"
                >
                    List View
                </b-button>
                <b-button
                    :variant="viewMode === 'board' ? 'primary' : 'outline-primary'"
                    size="sm"
                    class="toggle-btn"
                    @click="viewMode = 'board'"
                >
                    Board View
                </b-button>
            </div>
            <b-button variant="primary" class="btn-create-ticket" @click="$emit('create-ticket')">
                <i class="fa fa-plus mr-1"></i>
                Create Ticket
            </b-button>
        </div>

        <b-card class="tickets-card">
            <b-table
                :items="tickets"
                :fields="tableFields"
                responsive
                hover
                class="tickets-table"
                tbody-tr-class="ticket-row"
            >
                <template #cell(id)="data">
                    <b-button variant="link" class="link-ticket-id p-0" @click="viewTicket(data.item)">
                        {{ data.item.id }}
                    </b-button>
                </template>
                <template #cell(subject)="data">
                    <span class="ticket-subject">{{ data.item.subject }}</span>
                </template>
                <template #cell(status)="data">
                    <b-badge
                        pill
                        :class="['badge-status', 'status-' + (data.item.status || '').toLowerCase().replace(/\s/g, '-')]"
                    >
                        {{ data.item.status }}
                    </b-badge>
                </template>
                <template #cell(priority)="data">
                    <b-badge
                        pill
                        :class="['badge-priority', 'priority-' + (data.item.priority || '').toLowerCase()]"
                    >
                        {{ data.item.priority }}
                    </b-badge>
                </template>
                <template #cell(assignedTo)="data">
                    <span class="ticket-assigned">{{ data.item.assignedTo }}</span>
                </template>
                <template #cell(updated)="data">
                    <span class="ticket-updated">{{ data.item.updated }}</span>
                </template>
            </b-table>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "CrmTickets",
    props: {
        accountId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            viewMode: "list",
            tableFields: [
                { key: "id", label: "TICKET ID", thClass: "table-header" },
                { key: "subject", label: "SUBJECT", thClass: "table-header" },
                { key: "status", label: "STATUS", thClass: "table-header" },
                { key: "priority", label: "PRIORITY", thClass: "table-header" },
                { key: "assignedTo", label: "ASSIGNED TO", thClass: "table-header" },
                { key: "updated", label: "UPDATED", thClass: "table-header" },
            ],
            tickets: [
                { id: "#SR1523", subject: "Dashboard modification request", status: "In Progress", priority: "High", assignedTo: "Sarah Johnson", updated: "2026-02-10" },
                { id: "#SR1410", subject: "Billing interval change", status: "Closed", priority: "Medium", assignedTo: "Sarah Johnson", updated: "2026-01-15" },
            ],
        };
    },
    methods: {
        createTicket() {
            console.log("createTicket");
        },
        viewTicket(ticket) {
            console.log("viewTicket", ticket);
        },
    },
};
</script>

<style scoped>
.crm-tickets {
    padding: 0;
}

.tickets-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 24px;
}

.view-toggle-group {
    display: flex;
    gap: 0;
}

.toggle-btn {
    border-radius: 0;
    outline: none;
    box-shadow: none;
}

.toggle-btn:first-child {
    border-radius: 8px 0 0 8px;
}

.toggle-btn:last-child {
    border-radius: 0 8px 8px 0;
}

.btn-create-ticket {
    border-radius: 8px;
    font-weight: 600;
}

.tickets-card {
    border-radius: 12px;
    border: 1px solid #e9ecef;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    padding: 24px;
}

.tickets-card >>> .card-body {
    padding: 0;
}

.tickets-table >>> thead th {
    font-size: 0.7rem;
    font-weight: 800;
    letter-spacing: 0.05em;
    color: #6c757d;
    text-transform: uppercase;
    border-bottom: 1px solid #e9ecef;
    padding: 14px 16px;
}

.tickets-table >>> tbody td {
    padding: 16px;
    vertical-align: middle;
    border-bottom: 1px solid #f1f3f5;
}

.tickets-table >>> tbody tr.ticket-row:hover {
    background-color: #f8f9fa;
}

.tickets-table >>> tbody tr:last-child td {
    border-bottom: 0;
}

.link-ticket-id {
    font-weight: 600;
    color: #1565c0;
    font-size: 0.95rem;
}

.link-ticket-id:hover {
    color: #0d47a1;
    text-decoration: underline;
}

.ticket-subject {
    font-weight: 700;
    color: #1a1d21;
}

.badge-status.status-in-progress {
    background-color: #cce5ff !important;
    color: #004085 !important;
    font-weight: 500;
    padding: 6px 12px;
}

.badge-status.status-closed {
    background-color: #e2e3e5 !important;
    color: #383d41 !important;
    font-weight: 500;
    padding: 6px 12px;
}

.badge-priority.priority-high {
    background-color: #ffe5d0 !important;
    color: #c2410c !important;
    font-weight: 500;
    padding: 6px 12px;
}

.badge-priority.priority-medium {
    background-color: #cce5ff !important;
    color: #004085 !important;
    font-weight: 500;
    padding: 6px 12px;
}

.ticket-assigned {
    color: #495057;
}

.ticket-updated {
    color: #495057;
}

@media (max-width: 768px) {
    .tickets-toolbar {
        flex-direction: column;
        align-items: stretch;
    }

    .view-toggle-group {
        justify-content: center;
    }
}
</style>
